import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

import * as echarts from "echarts";
import {EChartsType} from "echarts/core";
import {onMounted} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'line',
  props: {
  className: {
    type: String,
    default: 'chart'
  },
  config:{
    type: Object,
    default: ()=>{}
  },
  id: {
    type: String,
    default: 'chart'
  },
  width: {
    type: String,
    default: '200px'
  },
  height: {
    type: String,
    default: '200px'
  },
  xdata:{
    type:Array,
    default:()=>[]
  },
  chartData:{
    type:Array,
    default:()=>[]
  },
},
  setup(__props) {

let props = __props
const options = {
  grid: {
    top: 10,
    left: '2%',
    right: '2%',
    bottom: '2%',
    containLabel: true
  },
  xAxis: {
    type: 'category',
    data: props.xdata
  },
  yAxis: {
    type: 'value'
  },
  series: [
    {
      data: props.chartData,
      type: 'line',
      color:'#0E9CFF',
      areaStyle: {
        opacity: 0.2,
        color: '#0E9CFF'
      },
    }
  ]
};
let chart:EChartsType;
const initChart =()=> {
  let chart = echarts.init(document.getElementById(props.id))
  chart.setOption(options)
  return chart
}
onMounted(()=>{
  chart = initChart()
  window.addEventListener('resize',function (){
    chart&&chart.resize()
  })

})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: __props.id,
    class: _normalizeClass(__props.className),
    style: _normalizeStyle({height:__props.height,width:__props.width})
  }, null, 14, _hoisted_1))
}
}

})